<template>
    <div>
        <innerheader />
        <NetworkAlert />
    </div>
</template>

<script>
// @ is an alias to /src
import innerheader from "@/components/innerheader/innerheader.vue";
import NetworkAlert from "@/components/alert/networkAlert.vue";

export default {
  name: 'alert',
  components: {
     innerheader,
     NetworkAlert
  }
}
</script>

<style scoped lang="scss">
@import '~@/assets/scss/components/paymentsuccess.scss';
</style>